import {FC} from 'react';
import TablePagination from 'components/Table/TableComponents/TablePagination';
import {setUrl} from 'utils/request';

type InboxPaginationProps = {
    currentPage: number;
    numPages: number;
    url: string;
};

const InboxPagination: FC<InboxPaginationProps> = ({
    currentPage,
    numPages,
    url,
}) => {
    const onRefresh = (page: number | 'last' = currentPage) => {
        const searchParams = new URLSearchParams(window.location.search);
        searchParams.set('page', page.toString());
        setUrl(`${url}?${searchParams.toString()}`);
    };

    return (
        <TablePagination
            className="mt-4 mb-8"
            hideIfOnlyOnePage={true}
            isAmbigousStop={true}
            onChange={(page) => onRefresh(page)}
            onFirst={() => onRefresh(1)}
            onLast={() => onRefresh('last')}
            pageCurrent={currentPage}
            pageStop={numPages}
        />
    );
};

export default InboxPagination;
